import { combineReducers } from 'redux'
import { api } from 'reduxes/slices/api/reducers'
import { initialAppLocation } from 'reduxes/slices/app_location/reducers'
import { cablecar } from 'reduxes/slices/cablecar/reducers'
import { current } from 'reduxes/slices/current/reducers'
import { invalidRootStore as invalid } from 'reduxes/slices/invalid/reducers'
import { favicons, routes } from 'reduxes/slices/routes/reducers'

import { apiErrors } from '../../slices/api_errors/reducers'
import { topicIdInCookie } from '../../slices/topic_id_in_cookie/reducers'
import { errors } from '../../slices/errors/reducers'

const isRootStore = (state = true) => state
const liveChatApp = (state = false) => state
const liveChatAppId = (state = '') => state

export default combineReducers({
  cablecar,
  invalid,
  api,
  current,
  routes,
  isRootStore,
  favicons,
  initialAppLocation,
  apiErrors,
  topicIdInCookie,
  errors,
  liveChatApp,
  liveChatAppId,
})
